import { axios } from '@/utils/request'

/**
 * 查询检验、检查表
 *
 * @author zyy
 * @date 2023-02-07 21:51:56
 */
export function baSheetPage (parameter) {
  return axios({
    url: '/baSheet/page',
    method: 'get',
    params: parameter
  })
}

/**
 * 检验、检查表列表
 *
 * @author zyy
 * @date 2023-02-07 21:51:56
 */
export function baSheetReportList (parameter) {
  return axios({
    url: '/baSheet/report',
    method: 'get',
    params: parameter
  })
}

/**
 * 添加检验、检查表
 *
 * @author zyy
 * @date 2023-02-07 21:51:56
 */
export function baSheetAdd (parameter) {
  return axios({
    url: '/baSheet/add',
    method: 'post',
    data: parameter
  })
}

/**
 * 编辑检验、检查表
 *
 * @author zyy
 * @date 2023-02-07 21:51:56
 */
export function baSheetEdit (parameter) {
  return axios({
    url: '/baSheet/edit',
    method: 'post',
    data: parameter
  })
}

/**
 * 删除检验、检查表
 *
 * @author zyy
 * @date 2023-02-07 21:51:56
 */
export function baSheetDelete (parameter) {
  return axios({
    url: '/baSheet/delete',
    method: 'post',
    data: parameter
  })
}

/**
 * 导出检验、检查表
 *
 * @author zyy
 * @date 2023-02-07 21:51:56
 */
export function baSheetExport (parameter) {
  return axios({
    url: '/baSheet/export',
    method: 'get',
    params: parameter,
    responseType: 'blob'
  })
}
